import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import PATHS from '@/routes/paths'
import { acceptCatalogHandoffCode } from '@/services/auth/acceptCatalogHandoff'

/** On boot: if Catalog redirected with ?code=, exchange and enter the app. */
export function useCatalogCodeHandoff() {
  const [params, setParams] = useSearchParams()
  const navigate = useNavigate()
  const code = (params.get('code') || '').trim()
  const [error, setError] = useState('')
  // Start busy when code is present so CatalogCodeBootstrap never mounts
  // protected routes (and ROOT Navigate) before exchange finishes.
  const [busy, setBusy] = useState(() => Boolean(code))

  useEffect(() => {
    if (!code) return undefined
    let cancelled = false
    setBusy(true)
    ;(async () => {
      try {
        const msg = await acceptCatalogHandoffCode(code)
        if (cancelled) return
        if (msg) {
          setError(String(msg))
          return
        }
        setParams({}, { replace: true })
        navigate(PATHS.HOME, { replace: true })
      } catch (err) {
        if (!cancelled) {
          setError(err?.response?.data?.detail || err?.message || 'Catalog handoff failed')
        }
      } finally {
        if (!cancelled) setBusy(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [code]) // eslint-disable-line react-hooks/exhaustive-deps -- once per code

  return { code, busy, error }
}
